import { useRef } from "react";

export const useScrollContainer = () => {
  const scrollContainer = useRef(null);

  const scrollLeft = () => {
    const container = scrollContainer.current;
    if (!container) return;

    if (container.scrollLeft <= 0) {
      container.scrollLeft = container.scrollWidth - container.clientWidth;
    } else {
      container.scrollLeft -= 100;
    }
  };

  const scrollRight = () => {
    const container = scrollContainer.current;
    if (!container) return;

    if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
      container.scrollLeft = 0;
    } else {
      container.scrollLeft += 100;
    }
  };

  const showButtons = scrollContainer?.current?.scrollWidth > scrollContainer?.current?.clientWidth;

  return {
    scrollContainer,
    showButtons,
    scrollLeft,
    scrollRight
  };
};
